// removed by extract-text-webpack-plugin
module.exports = {"dialog":"EnterpriseConfirm__dialog___2TAWQ","footer":"EnterpriseConfirm__footer___1qMrc","footer--basic":"EnterpriseConfirm__footer--basic___3Bk0Q","confirmBtn":"EnterpriseConfirm__confirmBtn___2YlGI","cancelBtn":"EnterpriseConfirm__cancelBtn___1W7NX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseConfirm/EnterpriseConfirm.scss
// module id = 1006
// module chunks = 0